import { BaseApi } from './base.api.js';

export class RootCauseApi extends BaseApi {
    constructor(client, basePath = '/root-cause') {
        super(client, basePath);
    }

    async batchScope(payload) {
        return this.client.post(`${this.basePath}/batch-scope`, payload);
    }
}
